import { graphql, useStaticQuery } from 'gatsby';

export const siteMetaQuery = () => {
        const data = useStaticQuery(graphql`
          query SiteMetaQuery {
            site {
              siteMetadata {
                title
                slogan
                siteUrl
                sbuId
              }
            }
          }
        `);
    const title:string = data?.site.siteMetadata.title;
    const slogan:string = data?.site.siteMetadata.slogan;   
    const siteUrl:string = data?.site.siteMetadata.siteUrl;
    const sbuId:number | string = data?.site.siteMetadata.sbuId;
    return {
      title,
      slogan,
      siteUrl,
      sbuId
    }
}